import { Injectable } from '@angular/core';
import {
    MatDialog,
    MatDialogConfig,
    MatDialogRef,
} from '@angular/material/dialog';
import {
    MatSnackBar,
    MatSnackBarConfig,
    MatSnackBarRef,
    TextOnlySnackBar,
} from '@angular/material/snack-bar';
import { DialogComponent } from './dialog/dialog.component';
import { DialogModel } from './dialog/dialog.model';
import { OLSException } from './ols-exception';

@Injectable()
export class NotificationService {
    constructor(private snackbar: MatSnackBar, private dialog: MatDialog) {}
    private get defaultError() {
        return 'An error occurred while processing your request. Please try again.';
    }
    showSuccess(message: string): MatSnackBarRef<TextOnlySnackBar> {
        const config = new MatSnackBarConfig();
        config.horizontalPosition = 'center';
        config.verticalPosition = 'bottom';
        config.duration = 6000;

        return this.snackbar.open(message, null, config);
    }

    showFailure(
        error: any | string = this.defaultError,
        title: string = 'Something went wrong.'
    ): MatDialogRef<DialogComponent> {
        let errorMessage = this.defaultError;
        if (typeof error === 'string') {
            errorMessage = error;
        } else {
            try {
                const unpackedError: OLSException = JSON.parse(
                    error?.[0].message
                );

                errorMessage =
                    unpackedError.hasOwnProperty('message') &&
                    unpackedError?.status &&
                    unpackedError?.status >= 400 &&
                    unpackedError?.status < 500
                        ? unpackedError.message
                        : this.defaultError;
            } catch (_) {}
        }

        const config = new MatDialogConfig();
        config.data = new DialogModel(title, errorMessage);
        config.width = '33rem';

        const dialogRef = this.dialog.open(DialogComponent, config);

        try {
            console.error(error);
        } catch (err) {
            //Something's wrong with console.error, don't break everything because of it
        }

        return dialogRef;
    }
}
